<script setup>
defineProps({
    isDemo: {
        type: Boolean,
        default: false,
    },
    currentEnvironment: {
        type: String,
        default: 'production',
    },
});
</script>

<template>
    <!-- Demo Mode Banner -->
    <div v-if="isDemo && currentEnvironment === 'demo'" class="bg-orange-500 text-white text-center py-2 px-4 text-sm font-medium relative z-50">
        🚀 Demo Environment
    </div>

    <!-- Staging Mode Banner -->
    <div v-if="isDemo && currentEnvironment === 'staging'" class="bg-purple-600 text-white text-center py-2 px-4 text-sm font-medium relative z-50">
        🔧 Staging Environment
    </div>
</template>
